import * as THREE from 'three';
import type { GhostSample } from './RaceTypes';

export class GhostPlayer {
  private samples: GhostSample[] = [];
  private mesh: THREE.Mesh | null = null;

  setSamples(samples: GhostSample[]) {
    this.samples = samples;
  }

  attach(scene: THREE.Scene) {
    if (this.mesh) return;
    const geo = new THREE.BoxGeometry(1.8, 0.5, 3.6);
    const mat = new THREE.MeshStandardMaterial({
      color: 0x66f2ff,
      transparent: true,
      opacity: 0.35
    });
    this.mesh = new THREE.Mesh(geo, mat);
    this.mesh.castShadow = false;
    this.mesh.receiveShadow = false;
    scene.add(this.mesh);
  }

  detach(scene: THREE.Scene) {
    if (!this.mesh) return;
    scene.remove(this.mesh);
    this.mesh = null;
  }

  update(time: number) {
    if (!this.mesh || this.samples.length < 2) return;

    let idx = this.samples.findIndex((s) => s.t >= time);
    if (idx <= 0) idx = 1;
    if (idx >= this.samples.length) idx = this.samples.length - 1;

    const prev = this.samples[idx - 1];
    const next = this.samples[idx];
    const span = Math.max(0.0001, next.t - prev.t);
    const t = Math.min(1, Math.max(0, (time - prev.t) / span));

    const x = prev.x + (next.x - prev.x) * t;
    const y = prev.y + (next.y - prev.y) * t;
    const z = prev.z + (next.z - prev.z) * t;
    const heading = prev.heading + (next.heading - prev.heading) * t;

    this.mesh.position.set(x, y + 0.1, z);
    this.mesh.rotation.set(0, heading, 0);
  }
}
